var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseTemplate } from "./base-template";
import { NotificationType } from "../../../services/basics/notification-client.service";
import * as Enumerable from "linq";
import { Client } from "../../../views/app/client/client";
import { Guid } from "../../../utilities/guid";
import { RouterConstants } from "../../../configuration/router.constants";
import { SyndicateKeyHelper } from "../../../services/modules/brand-client.service";
var BaseSyndicate = /** @class */ (function (_super) {
    __extends(BaseSyndicate, _super);
    function BaseSyndicate(lotteryClientService, router, tokenClient, notificationClientService, i18N, eventAggregator, dialogClientService, bindingSignaler, gamePlayerTicketClientService) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClient) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.notificationClientService = notificationClientService;
        _this.eventAggregator = eventAggregator;
        _this.bindingSignaler = bindingSignaler;
        _this.gamePlayerTicketClientService = gamePlayerTicketClientService;
        _this.numberOfShares = 1;
        _this.animating = false;
        _this.bonusNumbers = [];
        _this.mainNumbers = [];
        _this.drawnBonusNumbers = [];
        _this.drawnMainNumbers = [];
        _this.chanceOfWinning = 0;
        _this.discountOffers = [];
        _this.previewData = [
            {
                discount: 5,
                price: 2,
                draws: 2,
                numberOfDraws: 2
            },
            {
                discount: 10,
                price: 2,
                draws: 4,
                numberOfDraws: 4
            },
            {
                discount: 20,
                price: 2,
                draws: 8,
                numberOfDraws: 8
            },
            {
                discount: 30,
                price: 2,
                draws: 12,
                numberOfDraws: 12
            }
        ];
        _this.syndicates = [];
        _this.isLoadingTickets = true;
        _this.loadTickets = function () {
            _this.isLoadingTickets = false;
            if (!_this.tokenClient.isPreview) {
                _this.isLoadingTickets = false;
                _this.checkSubscribeAndDefaultDiscount();
                _this.updateTicketNumbers();
            }
        };
        _this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
        return _this;
    }
    BaseSyndicate.prototype.numberOfSharesBlur = function () {
        if (this.numberOfShares > this.syndicate.numberOfShares) { // that means its bigger
            this.numberOfShares = this.syndicate.numberOfShares;
        }
        else if (this.numberOfShares < 1) { // that means it smaller
            this.numberOfShares = 1;
        }
        this.updateTotalPrice();
    };
    Object.defineProperty(BaseSyndicate.prototype, "availableMainPicks", {
        get: function () {
            return this.syndicate && this.syndicate.availableMainPicks ? this.syndicate.availableMainPicks.split(",") : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseSyndicate.prototype, "availableBonusPicks", {
        get: function () {
            return this.syndicate && this.syndicate.availableBonusPicks ? this.syndicate.availableBonusPicks.split(",") : [];
        },
        enumerable: false,
        configurable: true
    });
    BaseSyndicate.prototype.navigateToSyndicate = function (syndicate) {
        this.router.navigateToRoute(RouterConstants.RouteNames.Syndicate, {
            key: SyndicateKeyHelper.getKey(syndicate.name),
            syndicateId: syndicate.syndicateId,
            brandLotteryId: this.brandLotteryId
        });
        this.sendHeightToClient(this.lastKnownHeight + "px", false);
    };
    BaseSyndicate.prototype.navigateToLottery = function (lottery) {
        if (!this.tokenClient.isPreview) {
            var key = this.getLotteryKey(lottery.lotteryName);
            this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
                lotteryId: lottery.lotteryId,
                key: key,
                brandLotteryId: lottery.brandLotteryId,
                isSamePage: true // this wont scroll the page up
            }, { replace: true });
            this.sendHeightToClient(this.lastKnownHeight + "px", false);
        }
    };
    BaseSyndicate.prototype.activate = function (params) {
        var _this = this;
        var promise = _super.prototype.activate.call(this, params);
        this.key = params.key;
        if (params && params.cartGuid) {
            this.cartGuid = params.cartGuid;
        }
        if (params && params.isFromCart) {
            this.isFromCart = params.isFromCart;
        }
        if (params && params.syndicateId) {
            this.syndicateId = params.syndicateId;
        }
        if (params && params.brandLotteryId) {
            this.brandLotteryId = params.brandLotteryId;
        }
        if (params && params.draws) {
            this.draws = params.draws;
        }
        if (params && params.numberOfShares) {
            this.numberOfShares = params.numberOfShares;
        }
        else {
            this.numberOfShares = 1;
        }
        if (params && params.canRevert) {
            this.canRevert = params.canRevert;
        }
        if (params && params.isFromAgent) {
            this.isFromAgent = params.isFromAgent;
        }
        this.countryId = this.tokenClient.getCountryId();
        this.userCurrency = this.tokenClient.getUserCurrency();
        var syndicatePromise = this.lotteryClientService.getClientSyndicate({
            syndicateId: this.syndicateId,
            brandLotteryId: this.brandLotteryId
        }).then(function (syndicate) {
            _this.syndicate = syndicate;
            _this.loadSyndicateDetails();
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
        this.lotteryClientService.getBrandLotterySyndicates({
            brandLotteryId: this.brandLotteryId,
            brandId: this.tokenClient.user.brandId
        }).then(function (x) {
            _this.syndicates = x;
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
        return new Promise(function (resolve, reject) { return Promise.all([promise, syndicatePromise]).then(function (x) { return resolve(); }, reject); });
    };
    BaseSyndicate.prototype.addShare = function () {
        if (this.numberOfShares < this.syndicate.numberOfShares)
            this.numberOfShares = Number(this.numberOfShares) + 1;
        this.updateTotalPrice();
    };
    BaseSyndicate.prototype.removeShare = function () {
        if (this.numberOfShares > 1)
            this.numberOfShares = Number(this.numberOfShares) - 1;
        this.updateTotalPrice();
    };
    BaseSyndicate.prototype.attached = function () {
        var _this = this;
        _super.prototype.attached.call(this);
        if (this.isFromAgent) {
            // first show page and then load dialog
            setTimeout(function () {
                _this.showClientDetailsDialog();
            });
        }
    };
    BaseSyndicate.prototype.detached = function () {
        _super.prototype.detached.call(this);
    };
    BaseSyndicate.prototype.selectOffer = function (item, persistDrawChanges) {
        var _this = this;
        if (persistDrawChanges === void 0) { persistDrawChanges = true; }
        this.discountOffers.forEach(function (x) { return x.isSelected = false; });
        item.isSelected = true;
        this.updateTotalPrice();
        if (this.currentTimeOut)
            clearTimeout(this.currentTimeOut);
        var time = this.chanceOfWinning / 500;
        if (this.chanceOfWinning < item.chanceOfWinning) {
            var increase = function () { return setTimeout(function () {
                _this.chanceOfWinning++;
                if (_this.chanceOfWinning < item.chanceOfWinning)
                    _this.currentTimeOut = increase();
            }, time); };
            this.currentTimeOut = increase();
        }
        else if (this.chanceOfWinning > item.chanceOfWinning) {
            var decrease = function () { return setTimeout(function () {
                _this.chanceOfWinning--;
                if (_this.chanceOfWinning > item.chanceOfWinning)
                    _this.currentTimeOut = decrease();
            }, time); };
            this.currentTimeOut = decrease();
        }
    };
    BaseSyndicate.prototype.saveBulk = function (tickets, force) {
        var _this = this;
        if (force === void 0) { force = false; }
        return new Promise(function (resolve, reject) {
            if (!_this.canRevert || force) {
                var requests = Enumerable.from(tickets).select(function (a) { return _this.getCreateTicketRequest(a); }).toArray();
                var valid = Enumerable.from(requests).all(function (x) { return _this.validateRequest(x); });
                if (valid) {
                    _this.gamePlayerTicketClientService.createOrModifyTicketBulk(requests)
                        .then(function (x) { resolve(); })
                        .catch(function (x) {
                        _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
                        reject();
                    });
                }
                else {
                    reject();
                }
            }
            else {
                reject();
            }
        });
    };
    BaseSyndicate.prototype.loadSyndicateDetails = function () {
        var _this = this;
        if (this.syndicate && (this.syndicateId || this.tokenClient.isPreview)) {
            var lotteryBrandDiscountsEnumerable = Enumerable.from(this.syndicate.lotteryBrandDiscounts);
            //get the disounts filtered by country id match or null country
            this.discountOffers = this.tokenClient.isPreview ?
                this.previewData :
                lotteryBrandDiscountsEnumerable.orderBy(function (x) { return x.countryId; }).where(function (x) { return ((x.countryId == _this.countryId) || (x.countryId == null)); }).orderBy(function (x) { return x.numberOfDraws; }).toArray();
            //get ticket prices according to user country and currency of the user (order by lotteryJackpotRangeId so that those that have this set are selected first)
            var lotteryBrandPricesEnumerable = Enumerable.from(this.syndicate.lotteryBrandPrices).orderByDescending(function (x) { return x.lotteryJackpotRangeId; });
            //find the current jackpot range so that we can choose the ticket price for that range 
            this.lottery = Enumerable.from(this.lotteries).firstOrDefault(function (x) { return _this.brandLotteryId == x.brandLotteryId; });
            if (!this.lottery)
                return;
            this.ticketPrice = this.tokenClient.isPreview ?
                {
                    currencyId: Enumerable.from(this.tokenClient.currencies).where(function (x) { return x.currencyCode && x.currencyCode.toLowerCase() == "eur"; }).select(function (x) { return x.currencyId; }).firstOrDefault(),
                    price: this.previewData[0].price
                } :
                this.getPrice(lotteryBrandPricesEnumerable);
            this.mainNumbers = Enumerable.range(this.lottery.drawMinimumNumber, (this.lottery.drawMaximumNumber + 1) - this.lottery.drawMinimumNumber).toArray();
            this.drawnMainNumbers = Enumerable.range(1, this.lottery.drawnNumbers).toArray();
            if (this.lottery.drawnBonusMinimumNumber != null && this.lottery.drawnBonusMaximumNumber != null) {
                this.bonusNumbers = Enumerable.range(this.lottery.drawnBonusMinimumNumber, (this.lottery.drawnBonusMaximumNumber + 1) - this.lottery.drawnBonusMinimumNumber).toArray();
                this.drawnBonusNumbers = Enumerable.range(1, this.lottery.drawnBonusNumbers).toArray();
            }
            this.loadTickets();
            this.checkSubscribeAndDefaultDiscount();
            this.updateTicketNumbers();
            this.validateRequest(null);
        }
    };
    BaseSyndicate.prototype.checkSubscribeAndDefaultDiscount = function () {
        var _this = this;
        var discount = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return _this.draws && x.numberOfDraws == _this.draws; });
        var defaultDiscount = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isDefault; });
        if (discount) {
            this.selectOffer(discount, false);
        }
        else if (defaultDiscount) {
            this.selectOffer(defaultDiscount, false);
        }
        else if (this.discountOffers[0]) {
            this.selectOffer(this.discountOffers[0], false);
        }
    };
    BaseSyndicate.prototype.getPrice = function (enumerable) {
        var _this = this;
        var currentJackPotRange = Enumerable.from(this.syndicate.jackpotRanges).firstOrDefault(function (x) { return _this.lottery.totalJackpotInEuro >= x.rangeFrom && _this.lottery.totalJackpotInEuro <= x.rangeTo; });
        var currentJackPotRangeId = currentJackPotRange ? currentJackPotRange.lotteryJackpotRangeId : null;
        var query = enumerable.where(function (x) { return x.currencyId == _this.userCurrency.currencyId; });
        if (query.any(function (x) { return x.countryId == _this.countryId; }))
            query = query.where(function (x) { return x.countryId == _this.countryId; });
        else
            query = query.where(function (x) { return x.countryId == null; });
        if (query.any(function (x) { return x.lotteryJackpotRangeId == currentJackPotRangeId; }))
            query = query.where(function (x) { return x.lotteryJackpotRangeId == currentJackPotRangeId; });
        else
            query = query.where(function (x) { return x.lotteryJackpotRangeId == null; });
        return query.firstOrDefault();
    };
    BaseSyndicate.prototype.save = function (ticket, force) {
        var _this = this;
        if (force === void 0) { force = false; }
        if (!this.canRevert || force) {
            var request = this.getCreateTicketRequest(ticket);
            if (this.validateRequest(request)) {
                this.gamePlayerTicketClientService.createOrModifyTicket(request).catch(function (x) {
                    _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
                });
            }
        }
    };
    BaseSyndicate.prototype.getCreateTicketRequest = function (ticket) {
        var selectedDraw = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isSelected; });
        return {
            cartGuid: this.cartGuid,
            sequenceNumber: 0,
            bonusPicks: ticket.bonus.join(","),
            mainPicks: ticket.main.join(","),
            ticketGuid: ticket.guid,
            ticketId: ticket.ticketId,
            brandLotteryId: this.brandLotteryId,
            draws: selectedDraw ? selectedDraw.numberOfDraws : 0,
            recordedSessionId: Client.RECORDING_SESSION_ID,
            isFromCart: this.isFromCart,
            syndicateId: this.syndicate.syndicateId,
            numberOfShares: this.numberOfShares
        };
    };
    BaseSyndicate.prototype.getRemainingNumbers = function (ticket) {
        return this.getRemainingMain(ticket) + this.getRemainingBonus(ticket);
    };
    BaseSyndicate.prototype.getRemainingBonus = function (ticket) {
        return this.lottery.drawnBonusNumbers - ticket.bonus.length;
    };
    BaseSyndicate.prototype.getRemainingMain = function (ticket) {
        return this.lottery.drawnNumbers - ticket.main.length;
    };
    BaseSyndicate.prototype.validateRequest = function (request) {
        var draws = Enumerable.from(this.discountOffers).any();
        if (!draws) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-no-draws-set-up"), "", NotificationType.Warning);
            return false;
        }
        else if (request && request.draws <= 0) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-select-draw-number"), "", NotificationType.Warning);
            return false;
        }
        else if (!this.ticketPrice) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-prices-not-set-for-your-currency"), "", NotificationType.Warning);
            return false;
        }
        return true;
    };
    BaseSyndicate.prototype.getRandom = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };
    BaseSyndicate.prototype.shouldDeleteTicketOnMobile = function () {
        return true;
    };
    BaseSyndicate.prototype.updateTicketNumbers = function () {
        this.bindingSignaler.signal('update-selected-ticket-numbers');
        this.updateTotalPrice();
    };
    BaseSyndicate.prototype.updateTotalPrice = function () {
        this.bindingSignaler.signal('selected-offer-signal');
    };
    BaseSyndicate.prototype.getSelectedOffer = function () {
        var selected = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isSelected; });
        return selected;
    };
    BaseSyndicate.prototype.calculateTotalLines = function () {
        return this.syndicate ? this.syndicate.numberOfLines : 0;
    };
    BaseSyndicate.prototype.getStandardTicketPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.ticketPrice.price).toFixed(2);
        }
        return "";
    };
    BaseSyndicate.prototype.roundToTwoDecimalPlaces = function (x) {
        // 0.075 with the .toFixed does not round correctly
        return Math.round(x * 100) / 100;
    };
    BaseSyndicate.prototype.calculateTotalPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.getDiscountedPrice()).toFixed(2);
        }
        return this.tokenClient.getCurrencySymbol() + "0.00";
    };
    BaseSyndicate.prototype.getDiscountedPrice = function () {
        var ticketPicks = this.numberOfShares;
        var draws = this.getSelectedOffer() ? this.getSelectedOffer().numberOfDraws : 1;
        var discount = this.getSelectedOffer() ? this.getSelectedOffer().discount : 0;
        return (this.roundToTwoDecimalPlaces(this.calculateDiscountedPrice(discount, this.ticketPrice) * ticketPicks) * draws);
    };
    BaseSyndicate.prototype.calculateDiscountedPrice = function (discount, priceModel) {
        if (!priceModel)
            return null;
        var roundedPrice = priceModel.price;
        var discountedRoundedPrice = roundedPrice - this.roundToTwoDecimalPlaces((roundedPrice * discount) / 100);
        return discountedRoundedPrice;
    };
    BaseSyndicate.prototype.calculateCurrentDiscountedTicketPrice = function () {
        var discount = this.getSelectedOffer() ? this.getSelectedOffer().discount : 0;
        var discountedRoundedPrice = this.calculateDiscountedPrice(discount, this.ticketPrice);
        return this.roundToTwoDecimalPlaces(discountedRoundedPrice).toFixed(2);
    };
    Object.defineProperty(BaseSyndicate.prototype, "anySelectedTickets", {
        get: function () {
            return this.syndicate && this.syndicate.numberOfLines > 0 && this.numberOfShares > 0;
        },
        enumerable: false,
        configurable: true
    });
    BaseSyndicate.prototype.calculateDiscountedTicketPrice = function (discountModel) {
        var discountedRoundedPrice = this.calculateDiscountedPrice(discountModel.discount, this.ticketPrice);
        var finalPrice = Math.round(discountedRoundedPrice * 100) / 100;
        // console.log("Ticket Price: " + this.ticketPrice.price);
        // console.log("Discounted Ticket Price: " + discountedRoundedPrice);
        // console.log("Rounded Nearest Price: " + roundedPrice);
        // console.log("Discounted Final Rounded Ticket Price: " + finalPrice);
        return this.tokenClient.getCurrencySymbol() + this.roundToTwoDecimalPlaces(finalPrice).toFixed(2);
    };
    BaseSyndicate.prototype.buyTickets = function (clientDetails) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.isBuyingTickets) {
                reject();
                return;
            }
            var requests = Enumerable.from([_this.getSyndicateTicket()])
                .select(function (a) { return _this.getCreateTicketRequest(a); }).toArray();
            if (requests.length <= 0) {
                _this.noTicketsToPurchase();
            }
            else {
                if (_this.tokenClient.isAgent() && !clientDetails) {
                    _this.showClientDetailsDialog();
                    resolve(undefined);
                }
                else {
                    _this.isUnauthorized = false;
                    _this.isBuyingTickets = true;
                    if (_this.validateRequest(requests[0]))
                        _this.gamePlayerTicketClientService.purchaseTickets({
                            tickets: requests,
                            purchasedFromCart: false,
                            clientDetails: clientDetails
                        }).then(function (x) {
                            _this.isBuyingTickets = false;
                            _this.updateTicketNumbers();
                            if (!_this.tokenClient.isAgent()) // do not redirect if is agent since we show the ticket
                                _this.navigateToLobby();
                            _this.notificationClientService.show(_this.i18n.tr("success"), _this.i18n.tr("purchased-tickets-successfully-message"), NotificationType.Success);
                            _this.onPurchase();
                            resolve(x);
                        }, function (x) {
                            _this.isUnauthorized = x && x.statusCode == 401 && !_this.tokenClient.user.enableLoginDialog;
                            if (x && !_this.isUnauthorized)
                                _this.notificationClientService.show(_this.i18n.tr("error"), _this.i18n.tr(x.response), NotificationType.Error);
                            _this.isBuyingTickets = false;
                            reject();
                        });
                    else {
                        _this.isBuyingTickets = false;
                        reject();
                    }
                }
            }
        });
    };
    BaseSyndicate.prototype.addToCart = function () {
        var _this = this;
        if (this.isAddingToCart)
            return;
        this.isAddingToCart = true;
        var requests = Enumerable.from([this.getSyndicateTicket()])
            .select(function (a) { return _this.getCreateTicketRequest(a); })
            .toArray();
        if (!this.tokenClient.isAuthenticated) {
            this.notificationClientService.show(this.i18n.tr("not-authenticated-message"), this.i18n.tr("add-to-cart-not-logged-in-notification-message"), NotificationType.Warning);
        }
        if (requests.length <= 0) {
            this.isAddingToCart = false;
            this.noTicketsAddedToCart();
        }
        else {
            if (this.validateRequest(requests[0]))
                this.gamePlayerTicketClientService.addTicketsToCart({
                    tickets: requests
                }).then(function (x) {
                    _this.isAddingToCart = false;
                    _this.updateTicketNumbers();
                    _this.navigateToCart();
                    _this.eventAggregator.publish(Client.UpdateCartCount);
                    _this.ticketsAddedToCart();
                    window.dataLayer.push({
                        "event": "navigate_to_cart",
                        "syndicateId": _this.syndicateId,
                        "openedSyndicateName": _this.syndicate.syndicateName,
                        "openedSyndicateId": _this.syndicate.syndicateId,
                    });
                    _this.onAddedToCart();
                }, function (x) {
                    _this.isAddingToCart = false;
                });
            else
                this.isAddingToCart = false;
        }
    };
    BaseSyndicate.prototype.navigateToCart = function () {
        this.router.navigateToRoute(RouterConstants.RouteNames.Cart);
    };
    BaseSyndicate.prototype.update = function () {
        var _this = this;
        if (this.isUpdating)
            return;
        this.isUpdating = true;
        this.saveBulk([this.getSyndicateTicket()], true).then(function (x) {
            _this.isUpdating = false;
            _this.navigateToCart();
            _this.eventAggregator.publish(Client.UpdateCartCount);
            _this.updatedCart();
            window.dataLayer.push({
                "event": "navigate_to_cart",
                "syndicateId": _this.syndicateId,
                "openedSyndicateName": _this.syndicate.syndicateName,
                "openedSyndicateId": _this.syndicate.syndicateId,
            });
        }, function (x) {
            _this.isUpdating = false;
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
    };
    BaseSyndicate.prototype.getSyndicateTicket = function () {
        return {
            guid: Guid.generateGuid(),
            main: this.syndicate.availableMainPicks.split(",").map(function (x) { return Number(x); }),
            bonus: this.syndicate.availableBonusPicks ? this.syndicate.availableBonusPicks.split(",").map(function (x) { return Number(x); }) : []
        };
    };
    BaseSyndicate.prototype.onPurchase = function () { };
    BaseSyndicate.prototype.onAddedToCart = function () { };
    BaseSyndicate.prototype.showClientDetailsDialog = function () {
        var templateName = this.tokenClient.user.templateName.toLowerCase();
        try {
            require("./" + templateName + "/common/client-details-dialog");
        }
        catch (_a) {
            console.log("Cannot load client details dialog for template " + templateName);
        }
        this.dialogClient.show("app/styles/client/templates/" + templateName + "/common/client-details-dialog", this, false, true);
    };
    BaseSyndicate.prototype.updatedCart = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-updated-cart"), "", NotificationType.Success);
    };
    BaseSyndicate.prototype.noTicketsToPurchase = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-no-tickets-to-purchase"), "", NotificationType.Warning);
    };
    BaseSyndicate.prototype.noTicketsAddedToCart = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-no-tickets-to-add-to-cart"), "", NotificationType.Warning);
    };
    BaseSyndicate.prototype.ticketsAddedToCart = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-tickets-added-to-cart"), "", NotificationType.Success);
    };
    BaseSyndicate.prototype.previous = function (carouselBar) {
        var _this = this;
        if (this.animating) {
            return;
        }
        var scrollElement = $(carouselBar);
        if (scrollElement) {
            var currentScrollLeft = scrollElement.scrollLeft();
            var liCollection = scrollElement.children();
            var length_1 = liCollection.length;
            var accumulator = 0;
            for (var idx = 0; idx < length_1; idx++) {
                accumulator += $(liCollection[idx]).outerWidth();
                if (accumulator - currentScrollLeft > 5) {
                    break;
                }
            }
            if (scrollElement.get(0)) {
                var newScrollLeft = currentScrollLeft - $(liCollection[idx]).outerWidth();
                this.animating = true;
                scrollElement.animate({
                    scrollLeft: newScrollLeft
                }, "linear", function () {
                    _this.animating = false;
                });
            }
        }
    };
    BaseSyndicate.prototype.next = function (carouselBar) {
        var _this = this;
        if (this.animating) {
            return;
        }
        var scrollElement = $(carouselBar);
        if (scrollElement) {
            var currentScrollLeft = scrollElement.scrollLeft();
            var liCollection = scrollElement.children();
            var length_2 = liCollection.length;
            var accumulator = 0;
            for (var idx = 0; idx < length_2; idx++) {
                accumulator += $(liCollection[idx]).outerWidth();
                if (accumulator - currentScrollLeft > 5) {
                    break;
                }
            }
            var width = scrollElement.width();
            var offset = 8;
            if (scrollElement.get(0)) {
                var scrollWidth = scrollElement.get(0).scrollWidth;
                var newScrollLeft = currentScrollLeft + $(liCollection[idx]).outerWidth();
                this.animating = true;
                scrollElement.animate({
                    scrollLeft: newScrollLeft
                }, "linear", function () {
                    _this.animating = false;
                });
            }
        }
    };
    BaseSyndicate.prototype.calculateTotalPriceWithoutDiscount = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.calculateTotalPriceWithoutDiscountInternal()).toFixed(2);
        }
        return this.tokenClient.getCurrencySymbol() + "0.00";
    };
    BaseSyndicate.prototype.calculateTotalPriceWithoutDiscountInternal = function () {
        var draws = this.getSelectedOffer() ? this.getSelectedOffer().numberOfDraws : 1;
        return this.roundToTwoDecimalPlaces(this.ticketPrice.price) * draws;
    };
    BaseSyndicate.prototype.calculateTotalDiscountPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.calculateTotalPriceWithoutDiscountInternal() - this.getDiscountedPrice()).toFixed(2);
        }
        return this.tokenClient.getCurrencySymbol() + "0.00";
    };
    BaseSyndicate.prototype.shouldScrollTopOnLoad = function () {
        return false;
    };
    return BaseSyndicate;
}(BaseTemplate));
export { BaseSyndicate };
